/**
 * Static variables of all UI action ids.
 * This variables can be used in xml as UiAction="{id}".
 * @class UserAction
 */
export class UserAction {
    // sound
    static ActionToggleSound: string = "TOGGLE_SOUND";
    static ActionSoundOn1: string = "SOUND_ON1";
    static ActionSoundOn2: string = "SOUND_ON2";
    static ActionSoundOn3: string = "SOUND_ON3";
    static ActionSoundOff: string = "SOUND_OFF";

    // exit
    static ActionExit: string = "EXIT";

    // table color
    static ActionTableColor: string = "TABLE_COLOR_";

    // narrator language
    static ActionNarratorLanguage: string = "NARRATOR_LANGUAGE_";

    // settings
    static ActionGeneralSettingsOn: string = "GENERAL_SETTINGS_ON";
    static ActionGeneralSettingsOff: string = "GENERAL_SETTINGS_OFF";

    // statistics
    static ActionStatisticsOn: string = "STATISTICS_ON";
    static ActionStatisticsOff: string = "STATISTICS_OFF";
    static ActionToggleStatistics: string = "TOGGLE_STATISTICS";

    // paytable
    static ActionTogglePaytable: string = "TOGGLE_PAYTABLE";
    static ActionPaytableOn: string = "PAYTABLE_ON";
    static ActionPaytableOff: string = "PAYTABLE_OFF";

    // menu
    static ActionMenuOn: string = "MENU_ON";
    static ActionMenuOff: string = "MENU_OFF";
    static ActionToggleMenu: string = "TOGGLE_MENU";
    static ActionToggleMenuBack: string = "TOGGLE_MENU_BACK";
    static ActionSwitchControls: string = "SWITCH_CONTROLS";
    static ActionSwitchControlsLeft: string = "SWITCH_CONTROLS_LEFT";
    static ActionSwitchControlsRight: string = "SWITCH_CONTROLS_RIGHT";
    static ActionToggleHands: string = "TOGGLE_HANDS";

    // help
    static ActionHelpOn: string = "HELP_ON";
    static ActionHelpOff: string = "HELP_OFF";
    static ActionHelpTerminal: string = "TERMINAL_HELP_CYCLE";

    // bet
    static ActionToggleBet: string = "TOGGLE_BET";

    // quickspin
    static ActionQuickspinDialogOff: string = "QUICKSPIN_DIALOG_OFF";
    static ActionQuickspinToggle: string = "QUICKSPIN_TOGGLE";

    // ambient sound
    static ActionAmbientSoundToggle: string = "AMBIENT_SOUND_TOGGLE";
    // effects sound
    static ActionEffectsSoundToggle: string = "EFFECTS_SOUND_TOGGLE";
    // gender sound
    static ActionCommentarySoundToggle: string = "COMMENTARY_SOUND_TOGGLE";
    // commentary gender
    static ActionCommentaryGenderToggle: string = "COMMENTARY_GENDER_TOGGLE";

    static ActionGameRoundReport: string = "GAME_ROUND_REPORT";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/UserAction.ts
 **/